<template>
	<div class="jiangli">
		<div class="jiangli_top">
			<img @click="fanhui()" src="../../assets/images/licai/fanhui.png"/>
			<p class="">关于我们</p>
		</div>
		<div class="jiangli_con">
			<div class="jiangli_con_cnt">
				<h4> 关于我们</h4>
				<p>
ASM太平洋聚焦全球资产配置、产业投资与跨境金融服务，坚持专业、稳健、合规的经营理念，为客户提供长期价值服务。

公司以透明治理和风险控制为基础，围绕优质资产研究、项目筛选、资金管理和客户服务建立完整流程，持续为投资者创造稳健收益。

ASM太平洋重视用户资金安全和信息保护，平台全部余额、充值、提现、产品购买与返利展示统一使用 USD 计价，便于用户清晰核对每一笔资金变动。

ASM太平洋将持续完善产品体系和服务体验，以审慎的项目准入、清晰的收益规则和高效的客服支持，陪伴用户进行长期资产规划。</p>
			</div>
      
		</div>
	</div>
</template>

<script>
	export default {
		name: "jiangli",
		data: function() {
			return {
				types:0,
			};
		},
		created() {
	
		},
		mounted: function() {
			
		},
		methods: {
			fanhui:function(){
				this.$router.push({
					path:'/'
				})
			}
		},
	};
</script>
<style>
	h4{
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		line-height: 43px;
		opacity: 0.99;
	}
	.jiangli_con_cnt p{
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		line-height: 28px;
		opacity: 0.99;
	}
	.jiangli_con{padding: 30px 15px;}
	.jiangli_top{
		width: 100%;
		height: 45px;
		line-height: 45px;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.jiangli_top img{
		height: 30px;
		width: 30px;
		position: absolute;left: 0px;
	}
	.jiangli_top p{
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333!important;
		text-align: center;
	}
</style>

